"use strict";

const gtmHelpers = require("../helpers/gtmHelpers");
/**
 * Events of the component
 **/
const bindEvents = () => {
    const parentElements = document.querySelectorAll(".product-tile-carousel-wrapper");
    const initializedCarousels = document.querySelectorAll(".product-tile-carousel-wrapper .slick-slider:not(.einstein-carousel)");

    parentElements.forEach(parentElement => {
        parentElement.addEventListener("click", (event) => {
            if (event.target.closest(".product-tile-pd")) {
                gtmHelpers.selectItemEvent(event.target.closest(".product-tile-pd"));

                if ($(".pdp-container").length) {
                    const recommenderType = event.target.closest(".product-tile-carousel-wrapper").dataset.recommenderType;
                    gtmHelpers.recommendationClickEvent(recommenderType, event.target.closest(".product-tile-pd"));
                }
            }
        });
    });

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                gtmHelpers.viewItemListEvent(undefined, entry.target);
                gtmHelpers.promotionEvents("view_promotion", entry.target.parentElement);
                observer.unobserve(entry.target);
            }
        });
    });

    initializedCarousels.forEach((carousel) => {
        observer.observe(carousel);
    });
};

module.exports = {
    bindEvents
};
